import React, { useEffect, useState } from 'react'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { useTranslation } from '../contexts/i18n/use'
import { useHistory } from "react-router-dom"

export const MissingPage = () => {
  const theme = useTheme();
  const classes = useStyles(theme)
  const history = useHistory();
  const { actions: {t}} = useTranslation();

  useEffect(() => {
    console.log("I was here")
  },[])
 
  return (
    <div className={classes.container}>
      <Typography id="missing-explanation">
        { t('404.explanation')}
      </Typography>
      <Button className={classes.confirmbutton} id="missing-homebutton" onClick={() => { history.push("/") }}>
        <Typography id="missing-buttontext">
          { t('404.homebuttontext') }
        </Typography>
      </Button>
    </div>
  )
}

const useStyles = makeStyles({
  container: {
    backgroundColor: '#f4f4f4',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  buttonwrapper: {
    display: 'flex',
    flexDirection: 'row',
    padding: '1rem 0',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '80%'
  },
  picture: {
    maxWidth: '300px'
  },
  confirmbutton: theme => ({
    backgroundColor: theme.palette.error.main,
    color: theme.palette.button_text
  }),
  cancelbutton: theme => ({
    backgroundColor: theme.palette.info.main,
    color: theme.palette.button_text
  })
})